import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getResolution = (state) => resolveProp('market.resolution', state) || 'ip';

export default createSelector(getResolution, (resolution) => resolution);
